<template>
  <div class="privacy" id="privacy" style="height: auto">
    <p class="title">Privacy Policy</p>
    <div :class="!showmore ? 'privacymsg showmore' : 'privacymsg'">
      The developer of PesoCow is PesoCow ("we") has compiled this Privacy Policy. This Privacy Policy provides information on how we collect, use, store and protect users' personal information. Users should read this Privacy Policy carefully before using the services provided through the platform. By accessing and using the platform services, users indicate that they have read, understood and agreed to the contents of this Privacy Policy.

      <p>Main information we collect:</p>
      <strong>1. Contacts list information:</strong>When you use PesoCow to apply for a loan, PesoCow needs to obtain the information of the emergency contact you choose in the address book (including: contact number, contact name, relationship with the contact) to prevent the risk of fraud, and to confirm your credit rating , and ensure smooth communication. The collected data will be safely uploaded to the https://ho.helloworldheihei.com/ security center for encrypted storage and will never be shared with third parties.
      <br />
      <strong>2. SMS information:</strong> In order to ensure the safety of both parties' funds, when a user applies for a loan, PesoCow needs to obtain the user's SMS information (including: SMS title, SMS content, whether to read it) to evaluate the user's value and conduct anti-fraud analysis. The collected SMS information will be encrypted and uploaded to https://ho.helloworldheihei.com/, and will never be shared with any third party.
      <br />
      <strong>3. Personal information:</strong>including name, identification information (to identify the user and help them apply for a loan), mobile phone number (for login and registration).
      <br />
      <strong>4. Financial information:</strong>Financial account number, which is used to
      disburse the loan once it has been approved. <br />
      <strong>5. Camera Information:</strong> Authorize us to access or take photos/videos from
      your camera in order to help us verify your identity to expedite your loan
      process. <br />
      <strong>6. Location Information:</strong> Authorize us to access your location information,
      we will only obtain your location information while you are using our
      application. <br />
      <!-- <strong>7. Storage space: </strong>Access your device storage to check that your
      submissions are using your real information and not someone else using
      your identity to keep your account safe. <br /> -->
      <strong> 7.List of installed apps:</strong> As we are a financial app, we need access to the
      list of apps installed by users to prevent fraud and ensure the safety of
      funds. <br />
      <strong>8. Phone:</strong> It is necessary to obtain the user's phone information,
      including the phone number, which is a credential used by the platform to
      verify the user's identity. <br />
      <strong> 9. Network status:</strong>Need to obtain access to the user's network status,
      including wifi, mobile phone traffic, etc., to guard against unsafe
      network access. <br />
      <strong>10. Device information:</strong> including SSAID, MAC address, IMEI, hardware
      model, operating system version, etc., to ensure the safety and legality
      of users using this product. <br>
      <strong> 11. Social Account information:</strong> PesoCow needs to collect the user's social account (mobile phone number, email, etc.) during the user's loan process to verify the user's identity and contact the user; the collected information will be encrypted and stored at https://ho.helloworldheihei .com/, we attach great importance to the security of user information and will never share it with third parties.


      <p>How we use the information collected:</p>
      1. We will collect, use, store and process personal information in
      accordance with local laws and regulations. <br />
      2. We may delete some personal information that can identify you (make
      personal information anonymous) for the services provided by application
      development, database management and analysis. <br />
      3. We will not sell, lend or rent personal information to any party.
      <p>Purpose of collecting personal information:</p>
      1. Verify your identity and ensure the security of your account <br />
      2. Identify potential risks<br />
      3. Process loan applications and secure the transaction process when your
      loan is approved<br />
      4. For developing our mobile application in order to always meet the
      future needs of our customers
      <p>How we store and protect your personal information:</p>
      We upload the personal information we collect to our data security center (https://ho.helloworldheihei.com/), and we value the protection of users' personal information, so we are working hard to protect it in commercially acceptable ways. And as we continue to improve our protections, the confidentiality of your personal data is of the utmost importance to us. We will do our best to protect your personal data from unauthorized access, collection, processing, analysis, storage, disclosure, correction and deletion.

      <p>Change or delete your account：</p>
      You can log into our app at any time to view, edit or change your personal account information. If you want to delete your personal information, you can also contact us through the email below, and we will delete it after receiving your email(43gedgeeg@gmail.com). However, once a personal account is deleted, it cannot be recovered. Please consider carefully before deleting it. And when the user is inactive for a long time, we will delete it from time to time, you don't have to worry about the disclosure of information.
      <p>Changes to this Policy:</p>
      When you use our application, we assume that you have agreed and accepted the content of this privacy policy. We reserve the right to make changes at any time and will revise this Privacy Policy from time to time. Once this Privacy Policy is revised, it will take effect immediately. In order not to affect your use, we recommend that you review this Privacy Policy from time to time.

      <p>Contact us:</p>
      If you have any questions or suggestions about this Privacy Policy, please feel free to contact us at the following email address: 43gedgeeg@gmail.com.

      <p v-show="showmore && show != true" @click="showmore = !showmore" class="show"></p>
    </div>
  </div>
</template>

<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
<script>
export default {
  props: {
    show: "",
  },
  data() {
    return {
      showmore: true,
    };
  },
  created() {
    if (this.show == true) {
      this.showmore = false;
    }
  },
};
</script>
